import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
import "core-js/modules/web.dom.iterable";

const isArray = item => Array.isArray(item);

const isObj = item => typeof item === 'object';

const map = input => {
  if (isArray(input)) {
    return input.reduce((acc, item) => {
      acc.push(map(item));
      return acc;
    }, []);
  }

  if (isObj(input)) {
    return Object.keys(input).reduce((acc, key) => {
      acc[key] = map(input[key]);
      return acc;
    }, {});
  }

  return input;
};

export default {
  name: 'ProductSheetTcVars',
  props: {
    tcVars: {
      type: Object,
      required: true
    },
    tracking: {
      type: Object,
      required: true
    },
    productCross: {
      type: Object,
      default: null
    },
    productCrossComplementary: {
      type: Object,
      default: null
    }
  },

  created() {
    this.setTcVars('init product sheet');
    this.$root.$on('reset-tcvars', () => {
      this.setTcVars('product reset tcVars');
    });
    this.$root.$on('fnClickTracking', (context, data) => {
      this.fnClickTracking(context, data);
    });
    this.$root.$on('fnClickTrackingVariant', (context, data) => {
      this.fnClickTrackingVariant(context, data);
    });
    this.$watch('tcVars', () => {
      this.setTcVars('watcher product tcvars');
    });
  },

  beforeDestroy() {
    this.$root.$off('fnClickTracking');
    this.$root.$off('fnClickTrackingVariant');
  },

  methods: {
    fnClickTracking(context, data) {
      try {
        window.mdm_events(this.tracking.container_id, context.currentTarget, this.tracking[data]['event-type'], this.tracking[data].params);
      } catch (e) {
        console.warn(e);
      }
    },

    fnClickTrackingVariant(context, data) {
      if (context.currentTarget.value === '') {
        return;
      }

      this.fnClickTracking(context, data);
    },

    setTcVars(message) {
      if (process.client) {
        this.setCrossWidget('similar');
        this.setCrossWidget('complementary');
      }

      if (process.client && this.$cookies.get('debugmdm')) {
        console.log(message, _objectSpread({}, map(this.tcVars)));
      }

      this.$root.$emit('updated-tcvars', this.tcVars);
    },

    setCrossWidget(widgetType) {
      const cross = widgetType === 'similar' ? this.productCross : this.productCrossComplementary;

      try {
        const widgetId = cross && cross.earlybirdsWidgets ? cross.earlybirdsWidgets.widgetId : null;
        const earlybirdsWidgets = JSON.parse(localStorage.getItem('EARLYBIRDS_WIDGETS')) || {};

        if (widgetId) {
          Object.assign(earlybirdsWidgets, {
            [widgetId]: cross.earlybirdsWidgets
          });
          localStorage.setItem('EARLYBIRDS_WIDGETS', JSON.stringify(earlybirdsWidgets));
          this.tcVars.earlybirds_widgets = earlybirdsWidgets;
          if (widgetType === 'similar') this.tcVars.earlybirds_xsell_similaire = widgetId;else if (widgetType === 'complementary') this.tcVars.earlybirds_xsell_complementaire = widgetId;
        }
      } catch (error) {
        if (this.$sentry) {
          this.$sentry.captureMessage(error);
        }
      }
    }

  },
  render: h => h(null)
};